import { faCircleDot } from '@fortawesome/free-regular-svg-icons/faCircleDot'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { useSnapshot } from 'valtio'
import { controlState } from '../../../store/controlState.ts'
import { centerMapOnPets } from '../../map/mapHelpers.tsx'
import { historyState } from '../../../store/historyState.ts'

interface Props {
    history?: boolean
}

export const CenterMapButton: React.FC<Props> = (props) => {
    const { history } = props
    const isOnMobile = useSnapshot(controlState).isOnMobileDevice
    const selectedPetId = (useSnapshot(historyState) as typeof historyState).selectedPetId
    const disabled = history ? !selectedPetId : false
    const size = isOnMobile ? '3x' : 'xl'

    return (
        <div onClick={() => centerMapOnPets(history, disabled)} className={'w-fit h-fit cursor-pointer'}>
            <FontAwesomeIcon icon={faCircleDot} size={size} color={disabled ? 'gray' : 'black'}/>
        </div>
    )
}
